import {
    TbHome,
    TbChartLine,
    TbSnowflake,
    TbList,
    TbCalendarStats,
    TbCalendar,
    TbCloudRain,
    TbBell,
    TbPlant,
    TbFlame,
    TbReceipt,
    TbMap,
    TbLogout,
    TbAntenna,
    TbUsers,
    TbKey,
    TbChartBar,
} from "react-icons/tb";
import Account from "views/Member/Account";
import Stations from "views/Member/Admin/Stations";
import Users from "views/Member/Admin/Users";
import AdminStats from "views/Member/Admin/AdminStats";
import Logout from "views/Member/Logout";
import MemberHome from "views/Member/MemberHome";
import ColdReport from "views/Member/Reports/ColdReport";
import MonthDataReport from "views/Member/Reports/MonthDataReport";
import YearTempReport from "views/Member/Reports/YearTempReport";
import RainDataReport from "views/Member/Reports/RainDataReport";
import NotFound from "views/Pages/NotFound";
import Cultures from "views/Member/Admin/Cultures";
import ApiKeys from "views/Member/Admin/ApiKeys";
import ModuleLocked from "views/Member/ModuleLocked";
import BalancoHidrico from "views/Member/Reports/BalancoHidrico";
import Notices from "views/Member/Notices";
import Heatmap from "views/Member/Heatmap";
import StationDataReport from "views/Member/Reports/StationDataReport";
import DetailedReport from "views/Member/Reports/DetailedReport";

var memberRoutes = [
    {
        path: "/members/home",
        name: "Página Inicial",
        component: MemberHome,
        icon: <TbHome />,
        type: 'member'
    },
    {
        path: "/members/reports/detailed",
        name: "Dados Detalhados",
        icon: <TbChartLine />,
        lock: true,
        component: DetailedReport,
        type: 'member'
    },
    {
        path: "/members/reports/cold",
        name: "Horas Frio",
        icon: <TbSnowflake />,
        lock: true,
        component: ColdReport,
        type: 'member'
    },
    {
        path: "/members/reports/data/daily",
        name: "Dados Diários",
        icon: <TbList />,
        lock: true,
        component: StationDataReport,
        type: 'member'
    },
    {
        path: "/members/reports/data/month",
        name: "Relatório Mensal",
        icon: <TbCalendarStats />,
        lock: true,
        component: MonthDataReport,
        type: 'member'
    },
    {
        path: "/members/reports/data/year",
        name: "Relatório Anual",
        icon: <TbCalendar />,
        lock: true,
        component: YearTempReport,
        type: 'member'
    },
    {
        path: "/members/reports/rain/year",
        name: "Chuva Mensal",
        icon: <TbCloudRain />,
        lock: true,
        component: RainDataReport,
        type: 'member'
    },
    {
        path: "/members/notices",
        name: "Alertas",
        icon: <TbBell />,
        lock: true,
        component: Notices,
        type: 'member'
    },
    {
        path: "/members/reports/balanco-hidrico",
        name: "Balanço Hídrico",
        icon: <TbPlant />,
        lock: true,
        component: BalancoHidrico,
        type: 'member',
        isModule: true,
        userHas: 'bhs',
    },
    {
        path: "/members/admin/heatmap",
        name: "Mapa de Calor",
        icon: <TbFlame />,
        component: Heatmap,
        lock: true,
        type: 'member'
    },
    {
        path: "/members/account",
        name: "Minha Conta",
        component: Account,
        icon: <TbReceipt />,
        type: 'member'
    },
    {
        path: "/",
        name: "Mapa",
        icon: <TbMap />,
        type: 'member'
    },
    {
        path: "/members/logout",
        name: "Logout",
        icon: <TbLogout />,
        component: Logout,
        type: 'member',
        menu: false
    },
    {
        path: "/members/module-locked",
        name: "Módulo Bloqueado",
        component: ModuleLocked,
    },



    {
        path: "/members/admin/stations",
        name: "Estações",
        icon: <TbAntenna />,
        component: Stations,
        type: 'admin'
    },
    {
        path: "/members/admin/users",
        name: "Usuários",
        icon: <TbUsers />,
        component: Users,
        type: 'admin'
    },
    {
        path: "/members/admin/stats",
        name: "Estatísticas",
        icon: <TbChartBar />,
        component: AdminStats,
        type: 'admin'
    },
    {
        path: "/members/admin/cultures",
        name: "Culturas",
        icon: <TbPlant />,
        component: Cultures,
        type: 'admin'
    },
    {
        path: "/members/admin/api-keys",
        name: "Chaves de API",
        icon: <TbKey />,
        component: ApiKeys,
        type: 'admin'
    },
    {
        path: "*",
        name: "404",
        component: NotFound,
    },
];
export default memberRoutes;
